<template>
  <div class="baselayout">
    <keep-alive :include="/Keep$/">
      <router-view></router-view>
    </keep-alive>

    <component :is="SiteHead"></component>
    <component :is="SiteFoot"></component>
  </div>
</template>

<script>
import Device from 'utils/device'
export default {
  name: 'BaseLayout',
  data() {
    const SiteHead = () => import('./SiteHead')
    const SiteHeadMobile = () => import('./SiteHeadMobile')
    const SiteFoot = () => import('./SiteFoot')
    const SiteFootMobile = () => import('./SiteFootMobile')
    return {
      SiteHead: Device.isMobile ? SiteHeadMobile : SiteHead,
      SiteFoot: Device.isMobile ? SiteFootMobile : SiteFoot
    }
  }
}
</script>